<div class="idp-information-sections">
  <div *ngIf="title" class="idp-information-sections__title">{{ title }}</div>
  <section class="idp-information-sections__container">
    <div *ngIf="message" class="idp-information-sections__container--message">
      <span class="idp-information-sections__container--body">
        <i
          aria-hidden="true"
          class="idp-information-sections__container--icon"
        ></i>
        <span
          [innerHTML]="message"
          aria-atomic="true"
          aria-live="polite"
          class="idp-information-sections__container--text"
        ></span>
      </span>
    </div>
    <div class="idp-information-sections__container--btn-section">
      <idp-button
        (notify)="notify()"
        [label]="'Delta.com'"
        [size]="'full-width'"
        class="idp-information-sections__container--btn"
      ></idp-button>
    </div>
  </section>
</div>
